import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/mentees`;

export const menteesLinks = {
  root: () => base,
  menteeProfile: (id: number) => `${base}/${id}`,
  menteeSkills: (id: number) => `${base}/${id}/skills`,
  mentorshipDetails: (id: number) => `${base}/${id}/mentorshipDetails`,
  taskCreation: (id: number) => `${base}/${id}/taskCreation`,
  endMentorship: (id: number) => `${base}/${id}/endMentorship`,
  tasksList: (id: number) => `${base}/${id}/tasks`,
  taskDetails: (id: number | ':id', taskId: number) => `${base}/${id}/taskDetails/${taskId}`,
};

export default menteesLinks;
